export enum ZindexValues {
  BREADCRUMB = '0',
  SIDEBAR = '0',
  HEADER = '0',
  DRAG_DROP_ITEMS = '50',
  DROPDOWNS = '1001',
  POPUPS = '1001',
  TOOLTIP = '10000',
}
